import { useField } from 'react-final-form';
import { VerdictType } from '../../../demandTypes';

export const useVerdictTypeFormValue = () => {
  const verdictTypeField = useField('verdictType', { subscription: { value: true } });
  return { value: verdictTypeField.input.value as VerdictType | undefined };
};
